import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  // Entrada suave do card quando uma nova IA é cadastrada pela DAI: aparece
  // deslizando levemente de baixo, com fade e um discreto realce de borda que
  // some. Roda só no mount, então apenas o card recém-adicionado anima.
  '@keyframes cardEnter': {
    '0%': {
      opacity: 0,
      transform: 'translateY(16px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  card: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.secondary.superLight}`,
    backgroundColor: theme.palette.background.default,
    boxShadow: 'none',
    '&:before': { display: 'none' },
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  // Animação de entrada — aplicada só quando o card surge no painel do chat
  // (cadastro pela DAI), não na tela de revisão.
  animatedCard: {
    animation: '$cardEnter 500ms ease-out both',
  },
  summaryContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  icon: {
    width: 36,
    height: 36,
    objectFit: 'contain',
  },
  iconFallback: {
    width: 36,
    height: 36,
    borderRadius: 8,
    backgroundColor: theme.palette.primary.light,
  },
  name: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    backgroundColor: theme.palette.cardSummaryBackground,
    borderRadius: 8,
  },
  fieldLabel: {
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },
  fieldValue: {
    color: theme.palette.text.primary,
    whiteSpace: 'pre-line',
  },
}))

export default useStyles
